import * as React from 'react';
import type { SVGProps } from 'react';

const SvgFacebook = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="12"
    height="21"
    viewBox="0 0 12 21"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.8031 10.5871H7.66017V20.9998H3.00291C3.00291 20.9998 3.00291 15.3103 3.00291 10.5871H0.789062V6.9069H3.00291V4.52649C3.00291 2.82166 3.87445 0.157715 7.70297 0.157715L11.1541 0.170011V3.74243C11.1541 3.74243 9.05696 3.74243 8.64921 3.74243C8.24145 3.74243 7.66173 3.93193 7.66173 4.74493V6.90762H11.2101L10.8031 10.5871Z"
      fill="currentColor"
    />
  </svg>
);
export default SvgFacebook;
